import orderBy from 'lodash/orderBy'
import reject from 'lodash/reject'
import * as React from 'react'
import { v4 as uuid } from 'uuid'

function useTableQuestionRow(questionRows: {}[], otherRows: {}[]) {
  const [extraRows, setExtraRows] = React.useState([])
  const [mergedRows, setMergedRows] = React.useState([])

  React.useEffect(() => {
    setMergedRows(
      orderBy([...questionRows, ...otherRows, ...extraRows], ['order'], ['asc'])
    )
  }, [questionRows, otherRows, extraRows])

  const addTableRow = React.useCallback(() => {
    const lastMergedItem = mergedRows[mergedRows.length - 1] ?? {}
    setExtraRows((p) => {
      const newItem = {
        help_text: '',
        id: uuid(),
        is_required: false,
        order: lastMergedItem.order + 1,
        text: '',
        local: true,
      }
      return [...p, newItem]
    })
  }, [mergedRows])

  const removeTableRow = React.useCallback((idToRemove, isLocal) => {
    setExtraRows((p) => reject(p, ({ id }) => id === idToRemove))
  }, [])

  return [mergedRows, addTableRow, removeTableRow]
}

export default useTableQuestionRow
